import type { RootState } from "store/reducers/main";
import { isInPersonAnswerYes } from "utils/in-person-intent";

// The attendee's own registration answer is the source of truth. Deriving here rather than caching it
// onto the event bundle means there is nothing to invalidate - every profile write is picked up.
// Not gated on in_person_auto_fill: that flag covers the link-param seeding, not in-person mode itself.
export const selectAttendeeInPersonEnabled = (state: RootState): boolean => {
	const eventChannel = state.LiveEventReducer?.eventBundle?.channel;
	const regSettings = state.LiveEventReducer?.eventBundle?.registration_settings;
	const blProfileUser = state.LiveEventReducer?.blProfileUser;

	if (!eventChannel) return false;

	// The admin master switch always wins: if the feature is off for the event, nobody is in-person.
	if (!regSettings?.adminInPersonAttendeeModeEnabled) {
		return false;
	}

	return !!isInPersonAnswerYes(blProfileUser?.profile?.[eventChannel]);
};
